import { FlexDiv, P } from 'components/generic/HomePageComponents'
import SearchFacet from 'components/Directories/SearchFacetsContainer/SearchFacet'
import { PROVIDERS, WithProvider, Provider } from 'utils/DirectoryParser'

const providerMatchesFacet = (provider, facet) => {
  return (
    provider != null && (provider.facetSlug === facet.slug || provider.facetKeyword === facet.slug)
  )
}

const getChecked = (directoryLinkInformation, directoryProvider, facet) => {
  if (directoryLinkInformation && directoryLinkInformation.directoryProviders) {
    for (const provider of directoryLinkInformation.directoryProviders) {
      if (providerMatchesFacet(provider, facet)) {
        return true
      }
    }
  }

  return providerMatchesFacet(directoryProvider, facet)
}

const buildFacets = (
  siteDirectoryResultsTypes,
  facets,
  directoryProvider,
  directoryLinkInformation,
  type
) => {
  if (!facets) {
    return null
  }
  const selectedProvider = facets.find((facet) =>
    getChecked(directoryLinkInformation, directoryProvider, facet)
  )
  let selectedFacet = null
  if (selectedProvider) {
    const selectedProviderDirectoryLinkInformation = WithProvider(
      directoryLinkInformation,
      siteDirectoryResultsTypes,
      Provider(selectedProvider.slug)
    )
    selectedFacet = (
      <SearchFacet
        href={selectedProvider.path}
        type={type}
        checked={true}
        facetName={selectedProvider.name}
        count={selectedProvider.count}
        directoryLinkInformation={selectedProviderDirectoryLinkInformation}
      />
    )
  }
  let remainingFacets = facets
  if (selectedProvider) {
    remainingFacets = facets.filter((facet) => facet !== selectedProvider)
  }
  const otherFacets = remainingFacets.map((facet, i) => {
    if (providerMatchesFacet(PROVIDERS.BABYSITTERS, facet)) {
      return null
    }
    const newDirectoryLinkInformation = WithProvider(
      directoryLinkInformation,
      siteDirectoryResultsTypes,
      Provider(facet.slug)
    )
    const checked = getChecked(directoryLinkInformation, directoryProvider, facet)
    return (
      <SearchFacet
        key={i}
        href={facet.path}
        type={type}
        checked={checked}
        facetName={facet.name}
        count={facet.count}
        directoryLinkInformation={newDirectoryLinkInformation}
      />
    )
  })

  return (
    <>
      {selectedFacet}
      {otherFacets}
    </>
  )
}

const ProviderRadioFacets = ({
  facetName,
  siteDirectoryResultsTypes,
  providerRadioFacets,
  directoryProvider,
  directoryLinkInformation,
}) => {
  if (!providerRadioFacets) {
    return null
  }
  const radioProviderFacets = buildFacets(
    siteDirectoryResultsTypes,
    providerRadioFacets,
    directoryProvider,
    directoryLinkInformation,
    'radio'
  )
  return (
    <>
      <FlexDiv justifyContent='space-between'>
        <P lineHeight='20px' fontWeight='bold' fontSize='14px'>
          {facetName}
        </P>
      </FlexDiv>
      {radioProviderFacets}
    </>
  )
}

// TODO: Get Name from BE
const ProviderMultiFacets = ({
  siteDirectoryResultsTypes,
  providerMultiSelectFacets,
  directoryProvider,
  directoryLinkInformation,
}) => {
  if (!providerMultiSelectFacets || providerMultiSelectFacets.length <= 0) {
    return null
  }
  const multiSelectProviderFacets = buildFacets(
    siteDirectoryResultsTypes,
    providerMultiSelectFacets,
    directoryProvider,
    directoryLinkInformation,
    'checkbox'
  )
  return (
    <>
      <FlexDiv justifyContent='space-between'>
        <P lineHeight='20px' fontWeight='bold' fontSize='14px'>
          Type of Service
        </P>
      </FlexDiv>
      {multiSelectProviderFacets}
    </>
  )
}

const sumOfFacetCounts = (providerFacets) => {
  if (!providerFacets) {
    return 0
  }
  let sum = 0
  for (const providerFacet of providerFacets) {
    sum += providerFacet.count
  }
  return sum
}

const ProvidersContainer = ({
  facetName,
  siteDirectoryResultsTypes,
  providerRadioFacets,
  providerMultiSelectFacets,
  directoryProvider,
  directoryLinkInformation,
}) => {
  if (sumOfFacetCounts(providerRadioFacets) === 0) {
    return null
  }

  return (
    <>
      <ProviderRadioFacets
        facetName={facetName}
        siteDirectoryResultsTypes={siteDirectoryResultsTypes}
        directoryLinkInformation={directoryLinkInformation}
        providerRadioFacets={providerRadioFacets}
        providerMultiSelectFacets={providerMultiSelectFacets}
        directoryProvider={directoryProvider}
      />
      <ProviderMultiFacets
        siteDirectoryResultsTypes={siteDirectoryResultsTypes}
        directoryLinkInformation={directoryLinkInformation}
        providerMultiSelectFacets={providerMultiSelectFacets}
        directoryProvider={directoryProvider}
      />
    </>
  )
}

export default ProvidersContainer
